import { composeIO } from 'react-compose-io'
import { resumoConciliacaoIO } from './ResumoConciliacao.IO'
import { ResumoConciliacaoView } from './ResumoConciliacao.View'

export const ResumoConciliacao = composeIO(ResumoConciliacaoView, resumoConciliacaoIO)
